export default function getResource(label, vars = []) {
    const resources = {
        errorDescriptionLine1: 'Sorry, the page you’re looking for cannot be found',
        errorDescriptionLine2: 'Shop beauty at Sephora in the meantime.',
        ctaText: 'Shop Now'
    };

    return resources[label];
}
